import React, {FC} from "react";
import {Container, InfoText} from "../ui";
import {Button, Image} from "@fluentui/react-northstar";
import {IconsContainer, InnerContainer} from "./styles"
import getUrl from "../../helpers/images/getUrl";
import arrows from "../ui/Icons/arrows.svg";
import perkboxSquare from "../ui/Icons/perkboxSquare.svg";
import teamsSquare from "../ui/Icons/teamsSquare.svg";

interface Props {
  notify: () => void
}

const LoginSuccessful: FC<Props> = ({notify}) => {
  return (
    <Container>
      <IconsContainer>
        <Image src={getUrl(perkboxSquare)} />
        <Image src={getUrl(arrows)} />
        <Image src={getUrl(teamsSquare)} />
      </IconsContainer>
      <InfoText style={{fontSize: "20px", fontWeight: "700"}}>Login Successful</InfoText>
      <InfoText style={{fontSize: "19px"}}>Your Perkbox account is now linked with Microsoft Teams</InfoText>
      <InnerContainer>
        <Button
          primary
          styles={{
            margin: "auto",
            width: "100%",
            height: "100%",
            fontSize: "19px"
          }}
          onClick={notify}>
          Continue
        </Button>
      </InnerContainer>
    </Container>
  )
}

export default LoginSuccessful
